// extracted by mini-css-extract-plugin
export default {"Auth__option":"FormFooter_Auth__option__32eod"};